import { fromJS } from 'immutable';
import * as subcomponentActions from '../actions/subcomponent';
import { SUCCESS, START, ERROR } from '../actions/global';
import { fetchingState, defaultPageSize } from '@constants';

const initialStats = {
  fields: {},
  objects: {},
  objectSubcomponents: {},
  subcomponentList: {
    pageSize: defaultPageSize,
    sortModel: [],
    currentPage: 0,
    loadingAction: '',
  },
  subcomponent: {},
};

export default (
  state = fromJS(initialStats),
  { type, data, subcomponentId },
) => {
  let newState;
  // let newSubcomponents;
  switch (type) {
    case subcomponentActions.OBJECTS_FETCH[START]:
      return state.setIn(['objects', 'state'], fetchingState.FETCHING);
    case subcomponentActions.OBJECTS_FETCH[SUCCESS]:
      newState = state.setIn(['objects', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['objects', 'data'],
        fromJS(data ? data.results : []),
      );
    case subcomponentActions.OBJECTS_FETCH[ERROR]:
      return state.setIn(['objects', 'state'], fetchingState.ERROR);

    case subcomponentActions.OBJECT_SUBCOMPONENTS_FETCH[START]:
      return state.setIn(
        ['objectSubcomponents', 'state'],
        fetchingState.FETCHING,
      );
    case subcomponentActions.OBJECT_SUBCOMPONENTS_FETCH[SUCCESS]:
      newState = state.setIn(
        ['objectSubcomponents', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['objectSubcomponents', 'data'],
        fromJS(data ? data.results : []),
      );
    case subcomponentActions.OBJECT_SUBCOMPONENTS_FETCH[ERROR]:
      return state.setIn(['objectSubcomponents', 'state'], fetchingState.ERROR);

    case subcomponentActions.SUBCOMPONENT_LIST_FETCH[START]:
      return state.setIn(['subcomponentList', 'state'], fetchingState.FETCHING);
    case subcomponentActions.SUBCOMPONENT_LIST_FETCH[SUCCESS]:
      newState = state.setIn(
        ['subcomponentList', 'state'],
        fetchingState.LOADED,
      );
      newState = newState.setIn(
        ['subcomponentList', 'totalCount'],
        data && data.results ? data.results.length : 0,
      );
      return newState.setIn(
        ['subcomponentList', 'data'],
        fromJS(data ? data.results : []),
      );
    case subcomponentActions.SUBCOMPONENT_LIST_FETCH[ERROR]:
      return state.setIn(['subcomponentList', 'state'], fetchingState.ERROR);

    case subcomponentActions.SUBCOMPONENT_FETCH[START]:
      return state.setIn(['subcomponent', 'state'], fetchingState.FETCHING);
    case subcomponentActions.SUBCOMPONENT_FETCH[SUCCESS]:
      newState = state.setIn(['subcomponent', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['subcomponent', 'data'],
        fromJS(data ? data.results[0] : null),
      );
    case subcomponentActions.SUBCOMPONENT_FETCH[ERROR]:
      return state.setIn(['subcomponent', 'state'], fetchingState.ERROR);

    case subcomponentActions.SUBCOMPONENT_UPDATE[START]:
      return state.setIn(['subcomponent', 'state'], fetchingState.SAVING);
    case subcomponentActions.SUBCOMPONENT_UPDATE[ERROR]:
      return state.setIn(['subcomponent', 'state'], fetchingState.ERROR);
    case subcomponentActions.SUBCOMPONENT_UPDATE[SUCCESS]:
      newState = state.setIn(['subcomponent', 'state'], fetchingState.LOADED);
      return newState.setIn(['subcomponent', 'data'], fromJS(data.results[0]));

    case subcomponentActions.SUBCOMPONENT_RESET_DATA:
      return state.setIn(['subcomponent'], fromJS({}));

    case subcomponentActions.SUBCOMPONENT_CREATE[START]:
      return state.setIn(['subcomponent', 'state'], fetchingState.SAVING);
    case subcomponentActions.SUBCOMPONENT_CREATE[SUCCESS]:
      newState = state.setIn(['subcomponent', 'state'], fetchingState.LOADED);
      return newState.setIn(['subcomponent', 'data'], fromJS(data.results[0]));
    case subcomponentActions.SUBCOMPONENT_CREATE[ERROR]:
      return state.setIn(['subcomponent', 'state'], fetchingState.ERROR);

    // case subcomponentActions.WEBPAGE_DUPLICATE[START]:
    //   return state.setIn([ 'webpageList', 'loadingAction' ], 'duplicate');
    // case subcomponentActions.WEBPAGE_DUPLICATE[ERROR]:
    //   return state.setIn([ 'webpageList', 'loadingAction' ], '');
    // case subcomponentActions.WEBPAGE_DUPLICATE[SUCCESS]:
    //   newWebpages = state.getIn([ 'webpageList', 'data' ]).toJS();
    //   newWebpages = [ data.results[0], ...newWebpages ];
    //   newState = state.setIn([ 'webpageList', 'loadingAction' ], '');
    //   return newState.setIn([ 'webpageList', 'data' ], fromJS(newWebpages));

    case subcomponentActions.SUBCOMPONENT_DELETE[SUCCESS]:
      let newSubcomponents = state.getIn(['subcomponentList', 'data']).toJS();
      newSubcomponents = newSubcomponents.filter(
        n => n.subcomponentID !== subcomponentId,
      );
      return state.setIn(
        ['subcomponentList', 'data'],
        fromJS(newSubcomponents),
      );

    default:
      return state;
  }
};
